import React, { useMemo } from "react";
import { Button } from "antd";
import { AppContext } from "contexts/app";
export default function BigButton({ children, style, ...rest }) {
  const [appState] = React.useContext(AppContext);
  const styleMerge = useMemo(
    () => ({
      boxShadow: "none",
      fontSize: 16,
      height: 54,
      borderRadius: 5,
      fontWeight: 900,
      color: appState.isDark ? "#fff" : "#1E2025",
      ...style,
    }),
    [appState.isDark]
  );

  return (
    <Button type="primary" style={styleMerge} {...rest}>
      {children}
    </Button>
  );
}
